<template>
  <v-dialog v-model="showDialog" max-width="600px">
    <template v-slot:activator="{ on }">
      <v-btn colo="primary" v-on="on">Agregar</v-btn>
    </template>
    <v-card>
      <v-card-title> Nueva generacion </v-card-title>
      <v-card-text>
        <v-form ref="form" v-model="validForm">

          <tipo-generacion-autocomplete @tipoGeneracion="setTipoGeneracion" />

          <v-text-field
            type="text"
            label="Descripción"
            v-model="descripcion"
            :rules="[rules.required]"
          />
          <v-text-field
            type="text"
            label="Nombre corto"
            v-model="nombreCorto"
            :rules="[rules.required, rules.counter10]"
          />
          <v-checkbox
            v-model="aplicaRetencion"
            label="Aplicar retencion"
          ></v-checkbox>
          <MyDatePicker
            fecha=""
            label="Fecha inicio del periodo"
            @fecha="setFechaInicio"
            :rules="[rules.required]"
          />
          <MyDatePicker
            fecha=""
            label="Fecha inicio del periodo"
            @fecha="setFechaFin"
          />
        </v-form>
      </v-card-text>
      <v-card-actions>
        <v-btn small color="primary" @click="guardar">Guardar</v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>
<script>
import axios from "axios";
import moment from "moment";
import MyDatePicker from "@/components/shared/MyDatePicker";
import TipoGeneracionAutocomplete from "@/components/shared/TipoGeneracionAutocomplete.vue";

export default {
  components: {
    MyDatePicker,
    TipoGeneracionAutocomplete,
  },
  data() {
    return {
      descripcion: "",
      nombreCorto: "",
      fechaInicio: null,
      fechaFin: null,
      tipoGeneracionId: null,
      aplicaRetencion: true,
      menu: false,
      showDialog: false,
      rules: {
        required: (value) => !!value || "Requerido.",
        counter: (value) =>
          (value && value.length <= 1000) || "Maximo 100 caracteres",
        counter10: (value) =>
          (value && value.length <= 10) || "Maximo 10 caracteres",
      },
      validForm: false,
    };
  },
  methods: {
    guardar() {
      let gen = {
        descripcion: this.descripcion,
        nombreCorto: this.nombreCorto,
        fechaInicio: this.fechaInicio,
        fechaFin: this.fechaFin,
        aplicaRetencion: this.aplicaRetencion,
        tipoGeneracion: {
          id: this.tipoGeneracionId
        }
      };
      console.log("agregar clicked", gen);
      axios
        .put("/generaciones", gen)
        .then((response) => {
          console.log(response);
          this.$emit("agregado", response.data);
          this.$refs.form.reset();
          this.showDialog = false;
        })
        .catch((err) => {
          console.log(err);
        });
    },
    setTipoGeneracion(e) {
      this.tipoGeneracionId = e.id;
    },
    parseDate(date) {
      if (!date) return null;

      if (!moment(date, "DD/MM/YYYY", true).isValid()) {
        this.date = null;
        return null;
      }

      const [day, month, year] = date.split("/");
      return `${year}-${month.padStart(2, "0")}-${day.padStart(2, "0")}`;
    },
    formatDate(date) {
      if (!date) return null;

      if (!moment(date, "YYYY-MM-DD", true).isValid()) {
        this.date = null;
        return null;
      }

      const [year, month, day] = date.split("-");
      return `${day}/${month}/${year}`;
    },
    setFechaInicio(fecha) {
      console.log("fecha inicio seleccionada", fecha);
      this.fechaInicio = fecha;
    },
    setFechaFin(fecha) {
      console.log("fecha fin seleccionada", fecha);
      this.fechaFin = fecha;
    },
  },
  watch: {
    date() {
      this.dateFormatted = this.formatDate(this.date);
    },
    menu(val) {
      val && this.$nextTick(() => (this.$refs.picker.activePicker = "YEAR"));
    },
  },
};
</script>